export const MultiDownloadId = 'multiple-download';
